import DefaultBulletList from '@tiptap/extension-bullet-list';

// Constants
import { DEFAULT_TIPTAP_EXTENSION_PRIORITY } from '../../tiptapTypes';

export const BulletList = DefaultBulletList.extend({
    // Add a high priority to ensure this extension's keyboard shortcuts work
    //  Otherwise, the Underline extension will override them due to some internal logic that ignores the "Shift"
    priority: DEFAULT_TIPTAP_EXTENSION_PRIORITY + 1,

    addOptions() {
        return {
            ...this.parent?.(),
            HTMLAttributes: { class: 'list-el' },
        };
    },

    addKeyboardShortcuts() {
        return {
            // Keeping the original Tiptap shortcut, in case it's standard
            'Mod-Shift-8': () => this.editor.commands.toggleBulletList(),
            'Mod-Shift-U': () => this.editor.commands.toggleBulletList(),
        };
    },
});
